import React from 'react';
import { useAuth } from '../../firebase/AuthContext';
import styles from './UserNameDisplay.module.css';

/**
 * ユーザーの表示名/メール/ゲスト表示を行う薄いプレゼンテーションコンポーネント。
 * props:
 *  - fallback: 未ログイン時の表示 (デフォルト 'ゲスト')
 *  - showEmailWhenNoDisplayName: displayName が無い場合に email を表示 (true)
 *  - maxLength: 長い名前を省略する最大文字数 (省略時 32)
 *  - prefix: 文頭に付ける文字列 (例: 'ようこそ')
 *  - className / style: 追加スタイル
 */
const UserNameDisplay = ({
  fallback = 'ゲスト',
  showEmailWhenNoDisplayName = true,
  maxLength = 32,
  prefix = '',
  className = '',
  style = {},
}) => {
  const { user, isAuthenticated } = useAuth() || {};

  let text = fallback;
  if (isAuthenticated && user) {
    text = user.displayName || (showEmailWhenNoDisplayName ? user.email : fallback) || fallback;
  }
  if (text && maxLength && text.length > maxLength) {
    text = text.slice(0, maxLength - 1) + '…';
  }
  if (prefix && text) {
    text = `${prefix}${prefix.endsWith(' ') ? '' : ' '}${text}`.trim();
  }

  return (
    <span className={`${styles.name} ${className}`} style={style} title={isAuthenticated && user ? (user.displayName || user.email) : undefined}>
      {text}
    </span>
  );
};

export default UserNameDisplay;
